/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Tax_RejectedInputs */

const vi_einvoice_tax_rejected = /** @type {(inputs: Einvoice_Tax_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cơ quan thuế không tiếp nhận dữ liệu`)
};

/**

* @param {Einvoice_Tax_RejectedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_tax_rejected = /** @type {((inputs?: Einvoice_Tax_RejectedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Tax_RejectedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_tax_rejected(inputs)
});